import classNames from 'classnames';
import React, { FC, useState } from 'react';
import useCollapse from 'react-collapsed';

import { Icon, IconTypes } from '@eika/icon';

import { MenuItem } from '../MenuTypes';
import MenuElement from './MenuElement';

export interface ExpandableMenuElement {
    isActive: boolean;
    item: MenuItem;
}

const ExpandableMenuElement: FC<ExpandableMenuElement> = ({ isActive, item }) => {
    const [isExpanded, setExpanded] = useState(isActive);
    const { getToggleProps, getCollapseProps } = useCollapse({
        isExpanded,
    });

    return (
        <li role="presentation" key={item.link.url} className="menu__item">
            <div className="menu__item--container">
                <a href={item.link.url}>{item.name}</a>
                {item.submenuItems && (
                    <button
                        className={classNames('menu__expand-button', {
                            expanded: isExpanded,
                        })}
                        {...getToggleProps({
                            onClick: () => setExpanded((expanded) => !expanded),
                        })}
                        type="button"
                        aria-label={isExpanded ? `Lukk undermeny ${item.name}` : `Åpne undermeny ${item.name}`}
                        role={undefined}
                    >
                        <Icon type={IconTypes.LITEN_PIL_NED} />
                    </button>
                )}
            </div>
            {item.submenuItems && (
                <ul {...getCollapseProps()} className="menu__submenu">
                    {item.submenuItems?.map((submenu) => <MenuElement key={submenu.id} menuItem={submenu} />)}
                </ul>
            )}
        </li>
    );
};

export default ExpandableMenuElement;
